import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguageContext";
import { ProtectedRoute } from "./components/app/ProtectedRoute";
import ScrollToTop from "./components/app/ScrollToTop";

import Landing from "./pages/Landing";
import FreeLanding from "./pages/FreeLanding";
import Pricing from "./pages/Pricing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Settings from "./pages/Settings";
import BookingPageSettings from "./pages/BookingPageSettings";
import Admin from "./pages/Admin";
import Dashboard from "./pages/Dashboard";
import LeadDetail from "./pages/LeadDetail";
import CalendarPage from "./pages/Calendar";
import Financials from "./pages/Financials";
import GrowthAI from "./pages/GrowthAI";
import PublicLeadForm from "./pages/PublicLeadForm";
import FindACleaner from "./pages/FindACleaner";
import PublicQuote from "./pages/PublicQuote";
import PaymentSuccess from "./pages/PaymentSuccess";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import SmsOptIn from "./pages/SmsOptIn";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/free" element={<FreeLanding />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/l/:ownerId" element={<PublicLeadForm />} />
            <Route path="/find-a-cleaner" element={<FindACleaner />} />
            <Route path="/q/:quoteId" element={<PublicQuote />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/sms-opt-in" element={<SmsOptIn />} />
            <Route path="/payment/success" element={
              <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute><Dashboard /></ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute><Settings /></ProtectedRoute>
            } />
            <Route path="/booking-page-settings" element={
              <ProtectedRoute><BookingPageSettings /></ProtectedRoute>
            } />
            <Route path="/financials" element={
              <ProtectedRoute><Financials /></ProtectedRoute>
            } />
            <Route path="/calendar" element={
              <ProtectedRoute><CalendarPage /></ProtectedRoute>
            } />
            <Route path="/growth-ai" element={
              <ProtectedRoute><GrowthAI /></ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute><Admin /></ProtectedRoute>
            } />
            <Route path="/leads/:id" element={
              <ProtectedRoute><LeadDetail /></ProtectedRoute>
            } />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
